import { CalendarDaysIcon, VideoCameraIcon } from '@heroicons/react/24/outline';
import { ChevronRightIcon } from '@heroicons/react/24/solid';
import { VITE_ONBOARDING_LIVE_SESSION_URL } from 'src/constants/envs';
import { useBusinessHours } from 'src/hooks/whatsapp/useBusinessHours.hook';
import { useAdvisorScheduleUrl } from 'src/hooks/whatsapp/useAdvisorScheduleUrl.hook';
import type { tWhatsAppConnectAdvisorHelpProps } from './WhatsAppConnectAdvisorHelp.types';
import './WhatsAppConnectAdvisorHelp.styles.scss';

export default function WhatsAppConnectAdvisorHelp(props: tWhatsAppConnectAdvisorHelpProps) {
  const { isLiveSessionAvailable } = useBusinessHours();
  const scheduleUrl = useAdvisorScheduleUrl();

  if (isLiveSessionAvailable) {
    return (
      <div className="WhatsAppConnectAdvisorHelp WhatsAppConnectAdvisorHelp--live">
        <div className="WhatsAppConnectAdvisorHelp__header">
          <span className="WhatsAppConnectAdvisorHelp__statusDotWrapper" aria-hidden="true">
            <span className="WhatsAppConnectAdvisorHelp__statusDotPulse" />
            <span className="WhatsAppConnectAdvisorHelp__statusDot" />
          </span>
          <div className="WhatsAppConnectAdvisorHelp__headerText">
            {props.translations.liveTitle ? (
              <p className="WhatsAppConnectAdvisorHelp__title">{props.translations.liveTitle}</p>
            ) : null}
            <p className="WhatsAppConnectAdvisorHelp__text">{props.translations.liveText}</p>
          </div>
        </div>

        <a
          href={VITE_ONBOARDING_LIVE_SESSION_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={props.onLiveClick}
          className="WhatsAppConnectAdvisorHelp__cta WhatsAppConnectAdvisorHelp__cta--primary"
        >
          <VideoCameraIcon className="WhatsAppConnectAdvisorHelp__ctaIcon" />
          <span className="WhatsAppConnectAdvisorHelp__ctaLabel">
            {props.translations.livePrimaryCta}
          </span>
          <ChevronRightIcon className="WhatsAppConnectAdvisorHelp__ctaChevron" />
        </a>

        <p className="WhatsAppConnectAdvisorHelp__secondaryRow">
          <span className="WhatsAppConnectAdvisorHelp__secondaryText">
            {props.translations.liveSecondaryText}
          </span>{' '}
          <a
            href={scheduleUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={props.onScheduleClick}
            className="WhatsAppConnectAdvisorHelp__secondaryLink"
          >
            {props.translations.liveSecondaryCta}
          </a>
        </p>
      </div>
    );
  }

  return (
    <div className="WhatsAppConnectAdvisorHelp">
      <div className="WhatsAppConnectAdvisorHelp__header">
        <CalendarDaysIcon
          className="WhatsAppConnectAdvisorHelp__icon"
          aria-hidden="true"
        />
        <div className="WhatsAppConnectAdvisorHelp__headerText">
          {props.translations.offlineTitle ? (
            <p className="WhatsAppConnectAdvisorHelp__title">
              {props.translations.offlineTitle}
            </p>
          ) : null}
          <p className="WhatsAppConnectAdvisorHelp__text">{props.translations.offlineText}</p>
        </div>
      </div>

      <a
        href={scheduleUrl}
        target="_blank"
        rel="noopener noreferrer"
        onClick={props.onScheduleClick}
        className="WhatsAppConnectAdvisorHelp__cta WhatsAppConnectAdvisorHelp__cta--primary"
      >
        <CalendarDaysIcon className="WhatsAppConnectAdvisorHelp__ctaIcon" />
        <span className="WhatsAppConnectAdvisorHelp__ctaLabel">
          {props.translations.offlinePrimaryCta}
        </span>
        <ChevronRightIcon className="WhatsAppConnectAdvisorHelp__ctaChevron" />
      </a>
    </div>
  );
}
